import { createSelector } from 'reselect'

export const getAllById = (state) => state.automations.all
export const getAll = createSelector([getAllById], (allById) =>
  Object.values(allById),
)
